import { render } from "./FilmsEditorGallery.vue?vue&type=template&id=640f85f5&scoped=true"
import script from "./FilmsEditorGallery.vue?vue&type=script&lang=js"
export * from "./FilmsEditorGallery.vue?vue&type=script&lang=js"

import "./FilmsEditorGallery.vue?vue&type=style&index=0&id=640f85f5&lang=scss&scoped=true"

import exportComponent from "D:\\main\\spacelab\\cinema-cms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-640f85f5"]])

export default __exports__